<ndt-account-register-view
   [callState]="callState$ | async"
   [dataSource]="dataSource$ | async"
   [isLoading]="isLoading$ | async"
   [hasNextPage]="hasNextPage$ | async"
   [pagingCallState]="pagingCallState$ | async"
   [totalCount]="totalCount$ | async"
   [accountPrivileges]="accountPrivileges$ | async"
   [name]="entityName"
   [columns]="columns"
   [showAllAccountsControl]="true"
   (create)="onCreate()"
   (loadMore)="onLoadMore()"
   (quickFilterChange)="onQuickFilterChange($event)"
   (showAllAccountsChanged)="onshowAllAccountsChanged($event)"
   (orderingOptionsChange)="onOrderingOptionsChange($event)"
   [orderingOptions]="orderingOptions$ | async"
   (resetMwi)="onResetMwi($event)"
>
</ndt-account-register-view>
